export enum ZoningCodeStatus {
    NONE,
    DRAFT,
    IN_TESTING,
    ACTIVE,
    INACTIVE
}

export function getPrettyZCStatus(zcStatus: number): string {
    return ['None', 'Draft', 'In Testing', 'Active', 'Inactive'][zcStatus];
}

export const ZoningCodeStatusArray = [
    ZoningCodeStatus.NONE,
    ZoningCodeStatus.DRAFT,
    ZoningCodeStatus.IN_TESTING,
    ZoningCodeStatus.ACTIVE,
    ZoningCodeStatus.INACTIVE
];
